export class LeadPassengerCriteria {
    passengerId: number;
}
